export const ButtonLink = {
  transclude: true,

  bindings: {
    type: '@',
    ngDisabled: '<',
  },

  template: `
    <button class="btn btn-link p-0"
      type="{{ $ctrl.ngType || 'button' }}"
      ng-disabled="$ctrl.ngDisabled"
      ng-transclude>
    </button>`,
};



// WEBPACK FOOTER //
// ./src/components/Button/ButtonLink.js